module.exports = __webpack_public_path__ + "de5492bbae8caa291655ecbe769f202c.svg";